import React from "react";
import { Box, Skeleton } from "@mui/material";

const SwapRebalanceInfoSkeleton = () => (
  <Box
    sx={{
      border: "1px solid #ccc",
      borderRadius: "4px",
      width: "100%",
      marginRight: 1,
      height: "100%",
      padding: 2,
      backgroundColor: "transparent",
    }}
  >
    {/* Header with Title and Next Button */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        mb: 2,
      }}
    >
      <Skeleton variant="text" width={120} height={32} sx={{ fontSize: "20px" }} />
      <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
    </Box>

    {/* Fund Strategy Name */}
    <Skeleton variant="text" width={200} height={28} sx={{ fontSize: "18px", mb: 2 }} />

    {/* Summary Table */}
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginBottom: 2,
        backgroundColor: "transparent",
        width: "70%", // Make it smaller, similar to the detailed table below
      }}
    >
      {/* Table Header */}
      <Box
        sx={{
          display: "flex",
          backgroundColor: "transparent",
          padding: "8px 12px",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Skeleton variant="text" width={60} height={20} sx={{ mr: 2 }} />
        <Skeleton variant="text" width={80} height={20} sx={{ mr: 2 }} />
        <Skeleton variant="text" width={60} height={20} />
      </Box>

      {/* Table Rows */}
      {Array.from({ length: 2 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            padding: "4px 12px",
            borderBottom: index < 1 ? "1px solid #ccc" : "none",
            backgroundColor: "transparent",
          }}
        >
          <Skeleton variant="text" width={60} height={16} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={60} height={16} />
        </Box>
      ))}
    </Box>

    {/* Position Legend */}
    <Box
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "center",
        marginBottom: 2,
      }}
    >
      {/* NEW POSITION */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
        />
        <Skeleton variant="text" width={120} height={20} />
      </Box>

      {/* CLOSING POSITION */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
        />
        <Skeleton variant="text" width={140} height={20} />
      </Box>
    </Box>

    {/* Detailed Positions Table */}
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "4px",
        height: "400px",
        overflow: "hidden",
        backgroundColor: "transparent",
        width: "70%", // Match the actual table width from the image
      }}
    >
      {/* Table Header */}
      <Box
        sx={{
          display: "flex",
          backgroundColor: "transparent",
          padding: "8px 5px",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Skeleton variant="text" width={60} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={80} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={60} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={60} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={100} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={80} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={80} height={20} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={100} height={20} />
      </Box>

      {/* Table Rows */}
      <Box sx={{ height: "350px", overflowY: "auto" }}>
        {Array.from({ length: 20 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              padding: "4px 5px",
              borderBottom: index < 19 ? "1px solid #ccc" : "none",
              backgroundColor: "transparent",
            }}
          >
            <Skeleton variant="text" width={60} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={80} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={60} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={60} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={100} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={80} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={80} height={16} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={100} height={16} />
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default SwapRebalanceInfoSkeleton;